// Configuración editorial del directorio privado de asistentes.
// Las 4 frases de "punto de partida" definen el círculo de llegada al evento.
// Ajustables en cualquier momento: el backend solo guarda el id ("01".."04").

export const PUNTO_PARTIDA = [
  {
    id: "01",
    pregunta:
      "¿Tienes un negocio que funciona, pero sientes que tu voz todavía no ocupa el lugar que merece?",
    descripcion:
      "Has construido algo sólido… y a la hora de comunicarlo, posicionarlo o defenderlo, todavía cedes espacio.",
    circulo: "Voz",
  },
  {
    id: "02",
    pregunta:
      "¿Lideras un equipo o una empresa y quieres hacerlo con más dirección, influencia y coherencia?",
    descripcion:
      "La responsabilidad ya la tienes. Lo que buscas es liderar con criterio propio, no en modo reactivo.",
    circulo: "Dirección",
  },
  {
    id: "03",
    pregunta:
      "¿Tienes agenda y reconocimiento, pero echas en falta relaciones que de verdad abran puertas?",
    descripcion:
      "Conoces a mucha gente… y todavía nadie te está presentando a quien necesitas para el siguiente salto.",
    circulo: "Red",
  },
  {
    id: "04",
    pregunta:
      "¿Estás en una nueva etapa —nuevo reto, nuevo mercado, nueva versión de ti— y toca posicionarte de nuevo?",
    descripcion:
      "Cambió el contexto y tienes que demostrar otra vez lo que ya habías demostrado. Esta vez, con voz propia.",
    circulo: "Impulso",
  },
];

export const circuloDe = (puntoPartidaId) =>
  PUNTO_PARTIDA.find((p) => p.id === puntoPartidaId)?.circulo || "";

export const DIRECTORY_CONSENT =
  "Acepto que mi foto y mis respuestas aparezcan en el directorio privado de asistentes de Lidera con Voz Propia · Edición Primer Aniversario, y que se usen para organizar los círculos y sugerirme conexiones dentro del evento. Responsable: Esther Parejo. Puedo retirar mi consentimiento en cualquier momento escribiendo a esther@lideraconvozpropia.com.";
